import { useContext, useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { cuentaCliente } from "../Rutas/Servicios";
import { HistorialPuntosInicial } from "../Model/Tablas/HistorialPuntos";
import { HistorialAmigoReferidoTabla } from "../Model/Tablas/HistorialAmigoReferidoTabla";
import { Tooltip } from 'react-tooltip'

function HistorialAmigoReferido() {
  
 
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
    const {SetLoading}=useContext(MensajeContActualizacion)
    const datos=[
        HistorialPuntosInicial
      ]
      const columns=useMemo(() => HistorialAmigoReferidoTabla, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
        
     },[])

     useEffect(()=>{
        ActualizarDatos();
     },[GuiaBusqueda])


     useEffect(()=>{
        ActualizarDatos();
        
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {

                const historialcargas=Get(cuentaCliente.HistorialAmigoReferidos.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado)})
            }
        }
        SetLoading(false);
     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex } = state
    return (
        <>

        
            <div className="card-body" style={{textAlign:"center"}}>
                <h3>Mis Amigos Referidos</h3>
            </div>
            

        {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="movPuntosRewards"> <div className="card-body" style={{textAlign:"center"}}>  <span className="content" >Sin amigos referidos</span></div>

                    </div></div>:<div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" >
                     <table  {...getTableProps()} className="table table-striped" >
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()} >
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                        {column.render('Header')=="Registrado"?<>
                                        <div >
                                            <a
                                            data-tooltip-id="Registro"
                                            
                                            >
                                            {column.render('Header')}
                                                <i className="bi-question-circle" style={{fontSize:"1em"}} ></i>
                                            </a>
                                        </div>
</>:column.render('Header')=="Ecode Amigo"?<>
<a
  data-tooltip-id="Ecode"
>
{column.render('Header')}
    <i className="bi-question-circle" style={{fontSize:"1em"}}></i>
</a></>:column.render('Header')=="Tus Referidos"?<>
<a
  data-tooltip-id="Referidos"
  data-tooltip-content="Correo de tus referidos"
>
{column.render('Header')}
    <i className="bi-question-circle" style={{fontSize:"1em"}}></i>
</a></>:column.render('Header')=="Tus puntos"?<>
<a
  data-tooltip-id="Puntos"
>
{column.render('Header')}
    <i className="bi-question-circle" style={{fontSize:"1em"}}></i>
</a></>
                                        :column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
                           {page.map((row: any) => {
                               prepareRow(row)
                               return (
                                   <tr {...row.getRowProps()} 
                                    >
                                       {row.cells.map((cell: any) => {
                                        
                                           return (
                                            cell.column.Header==="Registrado"?

                                            cell.value==="Registrado"?<td {...cell.getCellProps()}><i className="bi-check-circle" style={{color:"green"}}></i></td> :
                                            
                                            cell.value==="No Registrado"?<td {...cell.getCellProps()}><i className="bi-x-circle" style={{color:"red"}}></i></td>:
                                            <td {...cell.getCellProps()} >{cell.render('Cell')}</td>:

                                            cell.column.Header==="Tus puntos"?

                                            cell.value==="Listo"?<td {...cell.getCellProps()}> <i className="bi-check-circle" style={{color:"green"}}></i></td> :
                                            
                                            cell.value==="No listo"?<td {...cell.getCellProps()}><i className="bi-x-circle" style={{color:"red"}}></i></td>:
                                            <td {...cell.getCellProps()} >{cell.render('Cell')}</td>:

                                            <td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                           );
                                       })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
		  </div>

                    }

{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <a >
                    
                    <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                </a>
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                <a >
                    <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                   
                </a>
                
            </div>:null}
            <Tooltip id="Ecode" >
                Si tu amigo se registro, se muestra su casilla
                <br/>
                Si no, se muestra - (un guion)
            </Tooltip>
            <Tooltip id="Referidos" />
            <Tooltip id="Puntos" >
               <>
               <i className="bi-check-circle" style={{color:"green"}}></i>= Ya obtuviste tus puntos
               <br/>
               <i className="bi-x-circle" style={{color:"red"}}></i>= Tu amigo no alcanzo a comprar en el periodo correspondiente, no obtuviste tus puntos :{"("}
               
               </>
            </Tooltip>
            <Tooltip id="Registro">
                <>
                    <i className="bi-check-circle" style={{color:"green"}}></i>=Tu amigo ya se registro
                    <br/>
                    <i className="bi-x-circle" style={{color:"red"}}></i>= Tu amigo no alcanzo a registrarse en el periodo correspondiente, no obtuviste tus puntos :{"("}
               
               </>
            </Tooltip>
            
        </>
      
    );
  }
  
  export default HistorialAmigoReferido;
  